/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { Col, Input, Form, AutoComplete } from "antd";
import {
  checkNumbervalue,
  preventTextPaste,
  validateNumberMinValue,
} from "../../../../utils";

function RetailDoxAndNonDox({
  isNonDox,
  form,
  ewayBillValueCheck,
  shipmentContentOptions,
  childShipments,
  handleOnEnter,
  nonDoxValueReq,
  setNonDoxValueReq,
  disabledFeilds = false,
}) {
  const [childWeight, setChildWeight] = useState({
    child: 0,
    total: 0,
    totalVol: 0,
    totalVolChild: 0,
  });

  useEffect(() => {
    let totalChild = childShipments?.reduce(
      (sum, item) => +sum + parseFloat(item?.weight),
      0
    );
    let totalVolChild = childShipments?.reduce(
      (sum, item) => +sum + parseFloat(item?.volumetricWeight),
      0
    );

    setChildWeight({
      total: +form.getFieldValue("weight"),
      totalVol: +form.getFieldValue("volumetricWeight") || 0,
      child: +totalChild,
      totalVolChild: +totalVolChild?.toFixed(2),
    });
  }, [childShipments]);

  const volumCalculation = (e) => {
    // console.log(e.target.value, "e");
    let data = e?.target?.value;
    if (data?.length == 0) {
      setChildWeight((prev) => ({
        ...prev,
        child: +childWeight?.child,
        totalVolChild: +childWeight?.totalVolChild,
        totalVol: +childWeight?.totalVol,
      }));
      return;
    }

    const { length, width, height } = form.getFieldValue();
    const volume = ((+length * +width * +height) / 5000)?.toFixed(2);
    if (volume) {
      form.setFieldsValue({
        volumetricWeight: volume,
      });
    }
    let totalChild = childShipments?.reduce(
      (sum, item) => +sum + parseFloat(item?.weight),
      0
    );
    let totalVolChild = childShipments?.reduce(
      (sum, item) => +sum + parseFloat(item?.volumetricWeight),
      0
    );

    setChildWeight({
      total: +form.getFieldValue("weight") || 0,
      child: +totalChild || 0,
      totalVolChild: +totalVolChild?.toFixed(2) || 0,
      totalVol: +volume || 0,
    });
  };

  return (
    <>
      {isNonDox == "DOX" ? (
        <>
          <Col lg={3} sm={3} md={3}>
            <Form.Item
              label="Weight(Gms)"
              name="weight"
              initialValue={50}
              rules={[
                {
                  required: true,
                  message: "Enter weight",
                },
                () => ({
                  validator(_, value) {
                    if (!value && !value?.length) {
                      return Promise.reject();
                    }

                    if (value?.length) {
                      if (value < 50) {
                        return Promise.reject("Min weight: 50 Gm");
                      }

                      if (parseInt(value?.substring(1, 0)) === 0) {
                        return Promise.reject("Weight cannot be zero");
                      }

                      if (value && value?.split(".")?.length > 2) {
                        return Promise.reject("Enter only one decimal");
                      }

                      if (value > 10000) {
                        return Promise.reject("Max weight: 10000 Gm");
                      }
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  handleOnEnter(event, "insured");
                  // document.getElementById("submit_credit").blur();
                } else if (checkNumbervalue(event)) {
                  event.preventDefault();
                }
              }}
            >
              <Input
                type="number"
                disabled={disabledFeilds}
                maxLength={7}
                onInput={(e) => preventTextPaste(e, 7)}
                placeholder="Enter weight"
                // min={1}
              />
            </Form.Item>
          </Col>
        </>
      ) : (
        <>
          <div style={{ width: "12%", marginRight: "8px" }}>
            <Form.Item
              help={
                childShipments?.length ? (
                  <div style={{ fontSize: "11px", color: "rgb(80, 205, 137)" }}>
                    <span>
                      Child wt:
                      <span>{childWeight?.child + " kg"}</span>
                    </span>{" "}
                    <span>
                      Total wt:{" "}
                      {(+childWeight?.total + +childWeight?.child)?.toFixed(2) +
                        " kg"}
                    </span>
                  </div>
                ) : null
              }
              label={
                <span className="calculater-container-pikpin">
                  {childShipments?.length ? "Weight(Kg)" : "Weight (Kg)"}
                </span>
              }
              name="weight"
              rules={[
                {
                  required: true,
                  // maxLength: 3,
                  message: "Enter weight",
                },
                // {
                //   pattern: /^(?!0)(\d+(\.\d{1,2})?)?$/,
                //   message: "Enter weight of at least 1 kg",
                // },
                () => ({
                  validator(_, value) {
                    if (!value && !value?.length) {
                      return Promise.reject();
                    }

                    const stringValue = String(value);

                    // if (parseFloat(value) === 0.0 || value === 0) {
                    //   return Promise.reject("Min weight: 0.1");
                    // }
                    if (
                      parseFloat(value) === 0.0 ||
                      value === 0 ||
                      value === "0" ||
                      value === ".0"
                    ) {
                      return Promise.reject("Min weight: 0.1");
                    }

                    if (/^0\.0{2,}/.test(stringValue)) {
                      return Promise.reject("Invalid value");
                    }

                    if (stringValue && stringValue?.split(".")?.length > 2) {
                      return Promise.reject("Only one decimal allowed");
                    }

                    if (value > 499.99) {
                      return Promise.reject("Max weight: 499 kg");
                    }
                    return Promise.resolve();
                  },
                  //validateTrigger: "onSubmit",
                }),
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  handleOnEnter(event, "length");
                } else if (checkNumbervalue(event)) {
                  event.preventDefault();
                }
              }}
            >
              <Input
                id="weight"
                disabled={disabledFeilds}
                placeholder="Enter weight"
                maxLength={6}
                onChange={volumCalculation}
                // type="number"
                onInput={(e) => preventTextPaste(e, 6)}
                // min={1}
              />
            </Form.Item>
          </div>

          <div style={{ width: "10%", marginRight: "8px" }}>
            <Form.Item
              label={"Length(Cm)"}
              name="length"
              rules={[
                {
                  required: true,
                  message: "Enter length",
                },
                validateNumberMinValue("cannot be 0")(),
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  handleOnEnter(event, "width");
                } else if (checkNumbervalue(event) || event.key === ".") {
                  event.preventDefault();
                }
              }}
            >
              <Input
                placeholder="Enter length"
                disabled={disabledFeilds}
                maxLength={3}
                type="number"
                onInput={(e) => preventTextPaste(e, 3)}
                onChange={volumCalculation}
              />
            </Form.Item>
          </div>
          <Col lg={3} sm={6} md={3}>
            <Form.Item
              label="Width(Cm)"
              name="width"
              rules={[
                {
                  required: true,
                  message: "Enter width",
                },
                validateNumberMinValue("cannot be 0")(),
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  handleOnEnter(event, "height");
                } else if (checkNumbervalue(event) || event.key === ".") {
                  event.preventDefault();
                }
              }}
            >
              <Input
                placeholder="Enter width"
                disabled={disabledFeilds}
                onChange={volumCalculation}
                maxLength={3}
                type="number"
                onInput={(e) => preventTextPaste(e, 3)}
              />
            </Form.Item>
          </Col>
          <Col lg={3} sm={6} md={3}>
            <Form.Item
              label={
                <span className="calculater-container-pikpin">Height (Cm)</span>
              }
              name="height"
              rules={[
                {
                  required: true,
                  message: "Enter height",
                },
                validateNumberMinValue("cannot be 0")(),
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  handleOnEnter(event, "value");
                } else if (checkNumbervalue(event) || event.key === ".") {
                  event.preventDefault();
                }
              }}
            >
              <Input
                placeholder="Enter height"
                disabled={disabledFeilds}
                maxLength={3}
                type="number"
                onInput={(e) => preventTextPaste(e, 3)}
                onChange={volumCalculation}
              />
            </Form.Item>
          </Col>

          <div style={{ width: "12%", marginRight: "8px", marginLeft: "8px" }}>
            <Form.Item
              label="Vol weight (Kg)"
              name="volumetricWeight"
              help={
                childShipments?.length ? (
                  <div style={{ fontSize: "11px", color: "rgb(80, 205, 137)" }}>
                    <span>
                      Child wt:
                      <span>{+childWeight?.totalVolChild}kg</span>
                    </span>{" "}
                    <span>
                      Total wt:{" "}
                      {(
                        +childWeight?.totalVol + +childWeight?.totalVolChild
                      ).toFixed(2)}
                      kg
                    </span>
                  </div>
                ) : null
              }
            >
              <Input readOnly={true} type="number" disabled />
            </Form.Item>
          </div>
        </>
      )}
    </>
  );
}

export default RetailDoxAndNonDox;
